import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const AmenitiesTick = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.16699 10.8333L7.50033 14.1667L16.667 5"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AmenitiesTick;
